/* eslint-disable */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { Box, Flex, HStack, Text, useColorModeValue } from "@chakra-ui/react";

export function SidebarLinks(props) {
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue("white", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("white", "white");
  let textColor = useColorModeValue("#42505C", "white");

  const { routes } = props;
  const userRole = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).role : null;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      // Skip routes that don't match the user's role
      if (route.requiredRole && route.requiredRole !== userRole) {
        return null;
      }

      if (route.category) {
        return (
          <React.Fragment key={index}>
            <Text
              fontSize='0.875rem'
              color={activeColor}
              fontWeight='normal'
              ps={{
                sm: "10px",
                xl: "16px",
              }}
            >
              {route.name}
            </Text>
            {createLinks(route.items)}
          </React.Fragment>
        );
      } else if (
        (route.layout === "/admin" && userRole === "ADMIN") ||
        (route.layout === "/user" && userRole === "USER")
      ) {
        return (
          <NavLink key={index} to={route.layout + route.path} >
            {route.icon ? (
              <Box mb=".75rem">
                <HStack
                >
                  <Flex 
                    w='100%' 
                    alignItems='center' 
                    justifyContent='start' 
                    height='48px' 
                    p=".75rem 1rem"
                    gap='10px'
                    bg={
                      activeRoute(route.path.toLowerCase())
                        ? "#602CE8"
                        : "transparent"
                    }
                    borderRadius='6px'
                    _hover={{
                      cursor: 'pointer',
                      bg: activeRoute(route.path.toLowerCase())
                        ? "#602CE8"
                        : "rgba(96, 44, 232, 0.1)"
                    }}>
                    <Box
                      height="24px"
                      width="24px"
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeIcon
                          : textColor
                      }
                    >
                      {route.icon}
                    </Box>
                    <Text
                      textAlign='start'
                      fontSize='16px'
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeColor
                          : textColor
                      }
                      fontWeight='normal'
                    >
                      {route.name}
                    </Text>
                  </Flex>
                </HStack>
              </Box>
            ) : (
              <Box>
                <HStack
                >
                  <Text
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? activeColor
                        : inactiveColor
                    }
                    fontWeight='normal'
                    textAlign='start'
                  >
                    {route.name}
                  </Text>
                </HStack>
              </Box>
            )}
          </NavLink>
        );
      }
      return null;
    });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
